module.exports = __webpack_public_path__ + "img/rolls03.a63e5865.jpg";